import { useState, useEffect } from "react";
import Ellipsis from "@material-ui/icons/MoreHoriz";
import jwt_decode from "jwt-decode";
// import CancelOutlined from "@material-ui/icons/CancelOutlined";
// import { MdPictureAsPdf } from "react-icons/md";
import { BsFileEarmarkImageFill, BsCheck } from "react-icons/bs";
import { fabric } from "fabric";
// import { jsPDF } from "jspdf";
import loadFonts from "../../utils/fontsLoader";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import Button from '@material-ui/core/Button';
import axiosInstance from "../../utils/config";
import "./responsive.css";

export default function Design({
  design,
  deleteDesign,
  setActiveID,
  downloadNum,
}) {
  const { imgSrc, published, title, _id } = design;
  const [canvas, setCanvas] = useState("");
  const [dtUrl, setDtUrl] = useState("");
  const [accountType, setAccountType] = useState("client"),
    askDeletionConfirmation = () => {
      let myVal = window.confirm("Do you really want to delete this design?");
      var modal = document.getElementById("modal");
      modal.style.display = "none";
      if (myVal) {
        if (accountType === "creative") deleteDesign(design._id);
      }
    };
  let token = localStorage?.getItem("skiUserToken");

  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
    makeDesign();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const previewDesign = () => {
    window.scrollTo(0, 0);
    if (document.querySelector(".DesignPopup")) {
      document.querySelector(".DesignPopup").style.display = "flex";
    }
    setActiveID(design._id);
    // setClickedDesign()
  };
  //  const Jpge = () => {htmlToImage.toJpeg (document.getElementById('canva_border'), { quality: 0.95 })
  // .then(function (dataUrl) {
  //   var link = document.createElement('a');
  //   link.download = 'my-image-name.jpeg';
  //   link.href = dataUrl;
  //   link.click();
  // })};

  const makeDesign = () => {
    if (canvas !== "") canvas.dispose();

    let divs_nm = document
      .getElementById("modal")
      .getElementsByClassName("canvas-container");
    if (divs_nm.length > 0) {
      for (let i = 0; i < divs_nm.length; i++) {
        divs_nm[i].remove();
      }
      let elmt = document.createElement("canvas");
      elmt.id = "canvas_t";
      document.getElementById("canva_border").appendChild(elmt);
    }

    let canvi = new fabric.Canvas("canvas_t", {
      height: design.height,
      width: design.width,
      backgroundColor: "white",
    });

    canvi.loadFromJSON(
      design.templateFile,
      () => {
        const itext = new fabric.Textbox("", {
          left: 395,
          top: 490,
          fontFamily: "Fredoka One",
          fontSize: 12,
          fill: "#003c63",
          opacity: 1,
          textDecoration: "none",
          width: 110,
          evented: false,
          selectable: false,
        });
        canvi.add(itext);
        canvi.renderAll.bind(canvi);
        // data_url = canvi.toDataURL({
        //   width: design.width,
        //   height: design.height,
        //   left: 0,
        //   top: 0,
        //   format: "png",
        // });
      },
      function (o, object) {
        if (object) {
          object.editable = false;
          if (design.data) {
            if (
              o.type === "textbox" &&
              o.name === "title" &&
              o.category === "title"
            ) {
              object.text = design.data.title;
              console.log(o.width);
            }
            if (
              o.type === "textbox" &&
              (o.name === "title" || o.name === "body") &&
              o.category === "website"
            ) {
              if (design.data.website !== "") object.text = design.data.website;
              else object.visible = false;
            }
            if (
              o.type === "textbox" &&
              (o.name === "title" || o.name === "body") &&
              o.category === "email"
            ) {
              if (design.data.email !== "") object.text = design.data.email;
              else object.visible = false;
            }
            if (
              o.type === "textbox" &&
              (o.name === "title" || o.name === "body") &&
              o.category === "phone"
            ) {
              if (design.data.phone !== "") object.text = design.data.phone;
              else object.visible = false;
            }
            if (
              o.type === "textbox" &&
              o.name === "body" &&
              o.category === "none"
            ) {
              object.text = design.data.content;
            }
            // if (o.type === "image") console.log(o.category);
            if (
              o.type === "image" &&
              o.category === "logo" &&
              design.data.logo
            ) {
              let o_width = object.width;
              let o_height = object.height;

              object.setSrc(design.data.logo, () => {
                let scaleX = object.width / o_width / object.scaleX;
                let scaleY = object.height / o_height / object.scaleY;
                object.set({
                  scaleX: 1 / scaleX,
                  scaleY: 1 / scaleY,
                });
                canvi.renderAll();
              });
            }
            if (
              o.type === "image" &&
              o.level === "primary" &&
              o.category === "none" &&
              design.data.cimg
            ) {
              let o_width = object.width;
              let o_height = object.height;

              object.setSrc(design.data.cimg, () => {
                let scaleX = object.width / o_width / object.scaleX;
                let scaleY = object.height / o_height / object.scaleY;
                object.set({
                  scaleX: 1 / scaleX,
                  scaleY: 1 / scaleY,
                });
                canvi.renderAll();
              });
            }
            if (
              o.type === "line" ||
              o.type === "rect" ||
              o.type === "circle" ||
              o.type === "triangle" ||
              o.type === "path" ||
              o.type === "polygon"
            ) {
              if (
                o.level === "primary" &&
                design.data.color !== "" &&
                object.fill !== "rgba(0,0,0,0)"
              ) {
                object.fill = design.data.color;
              } else if (
                o.level === "primary" &&
                design.data.color !== "" &&
                object.fill === "rgba(0,0,0,0)"
              ) {
                object.stroke = design.data.color;
              }
            }
          }
        }
      }
    );

    // canvi.renderAll();
    setCanvas(canvi);
  };

  const destroyDesign = () => {
    var modal = document.getElementById("modal");
    modal.style.display = "none";
    if (canvas !== "") {
      canvas.dispose();
      setCanvas("");
    }
  };

  const addDownload = (type) => {
    console.log("DATS::", dtUrl);
    axiosInstance({
      method: "put",
      url: `/user/design/${_id}/download`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
      },
    })
      .then((res) => {
        if (type === "png") downloadAsPng();
        if (type === "svg") rasterizeSVG();
        // if (type === "pdf") downloadAsPdf();
        if (type === "jpeg") downloadAsJpg();
      })
      .catch((err) => console.log(err.response));
  };

  const downloadAsPng = () => {
    let canvi = document.getElementById("canvas_t");
    const dataURL = canvi.toDataURL({
      width: design.width,
      height: design.height,
      left: 0,
      top: 0,
      format: "png",
    });
    const link = document.createElement("a");
    link.download = "image.png";
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log("downloading png");
  };
  const downloadAsJpg = () => {
    let canvi = document.getElementById("canvas_t");
    const dataURL = canvi.toDataURL({
      width: design.width,
      height: design.height,
      left: 0,
      top: 0,
      format: "jpeg",
    });
    const link = document.createElement("a");
    link.download = "image.jpeg";
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log("downloading jpg");
  };

  const rasterizeSVG = () => {
    if (!canvas) return;
    let w = window.open("");
    w.document.write(canvas.toSVG());
    return "data:image/svg+xml;utf8," + encodeURIComponent(canvas.toSVG());
  };

  // const downloadAsPdf = () => {
  //   let canvi = document.getElementById("canvas_t");
  //   var imgData = canvi.toDataURL("image/jpeg", 1.0);
  //   var pdf = new jsPDF();

  //   pdf.addImage(imgData, "JPEG", 0, 0);
  //   pdf.save("download.pdf");
  // };

  const displayCanvas = (canvaId) => {
    let canvi = new fabric.Canvas(`${canvaId}`, {
      height: design.height,
      width: design.width,
      backgroundColor: "white",
    });

    canvi.loadFromJSON(
      design.templateFile,
      canvi.renderAll.bind(canvi),
      function (o, object) {
        // object.editable = false;
        if (object) {
          object.selectable = false;
          object.evented = false;
          if (design.data) {
            if (
              o.type === "textbox" &&
              o.name === "title" &&
              o.category === "title"
            ) {
              object.text = design.data.title;
            }
            if (o.type === "textbox" && o.category === "website") {
              if (design.data.website !== "") object.text = design.data.website;
              else object.visible = false;
            }
            if (o.type === "textbox" && o.category === "email") {
              if (design.data.email !== "") object.text = design.data.email;
              else object.visible = false;
            }
            if (o.type === "textbox" && o.category === "phone") {
              if (design.data.phone !== "") object.text = design.data.phone;
              else object.visible = false;
            }
            if (
              o.type === "textbox" &&
              o.name === "body" &&
              o.category === "none"
            ) {
              object.text = design.data.content;
            }
            if (
              o.type === "image" &&
              o.category === "logo" &&
              design.data.logo
            ) {
              let o_width = object.width;
              let o_height = object.height;

              object.setSrc(design.data.logo, () => {
                let scaleX = object.width / o_width / object.scaleX;
                let scaleY = object.height / o_height / object.scaleY;
                object.set({
                  scaleX: 1 / scaleX,
                  scaleY: 1 / scaleY,
                });
                canvi.renderAll();
              });
            }
            if (
              o.type === "image" &&
              o.level === "primary" &&
              o.category === "none" &&
              design.data.cimg
            ) {
              let o_width = object.width;
              let o_height = object.height;

              object.setSrc(design.data.cimg, () => {
                let scaleX = object.width / o_width / object.scaleX;
                let scaleY = object.height / o_height / object.scaleY;
                object.set({
                  scaleX: 1 / scaleX,
                  scaleY: 1 / scaleY,
                });
                canvi.renderAll();
              });
            }
            if (
              o.type === "line" ||
              o.type === "rect" ||
              o.type === "circle" ||
              o.type === "triangle" ||
              o.type === "path" ||
              o.type === "polygon"
            ) {
              if (
                o.level === "primary" &&
                design.data.color !== "" &&
                object.fill !== "rgba(0,0,0,0)"
              ) {
                object.fill = design.data.color;
              } else if (
                o.level === "primary" &&
                design.data.color !== "" &&
                object.fill === "rgba(0,0,0,0)"
              ) {
                object.stroke = design.data.color;
              }
            }
          }
        }
      }
    );
    loadFonts();
  };

  const editDesign = () => {
    window.location.href = `https://ski-editor.vercel.app?id=${design._id}&AUTH_TOKEN=${token}`;
  };

  useEffect(() => {
    if (canvas !== "")
      setDtUrl(
        canvas.toDataURL({
          width: design.width,
          height: design.height,
          left: 0,
          top: 0,
          format: "png",
          format: "jpg",
        })
      );
  }, [canvas]);

  useEffect(() => {
    if (token) {
      let decodedToken = jwt_decode(token);
      setAccountType(decodedToken.AccountType);
    }
  }, [token]);

  useEffect(() => {
    displayCanvas(_id);
  }, []);

  return (
    <div className=" start flex-row space-between flex-sm-wrap One-design">
      <div class="img">
        <Ellipsis className="more-icon" />
        <canvas id={_id} />
      </div>
      <h4>{title}</h4>
      <div>
        {accountType === "client" ? (
          <button
            className="download-design openBtn"
            id="openBtn"
            onClick={() => handleClickOpen()}
          >
            View
          </button>
        ) : (
          <button
            className="del-design dlt-btn"
            onClick={() => askDeletionConfirmation()}
          >
            Delete
          </button>
        )}
        {published && <BsCheck size={30} color="#2ba52b" title="Published" />}

        {accountType === "creative" && (
          <button onClick={editDesign}>Edit</button>
        )}
      </div>

      {/* <div
        className={` start modal hidden fixed z-10 left-0 top-0 overflow-auto`}
        style={{
          backgroundColor: "rgb(0,0,0)",
          backgroundColor: "rgba(0,0,0,0.4)",
          width: "100%",
        }}
        id="modal"
      >
      </div> */}
      <Dialog
        id="modal"
        open={open}
        maxWidth={"md"} // 'sm' || 'md' || 'lg' || 'xl'
        keepMounted
        style={{borderRadius: 5}}
        onClose={handleClose}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      > 
        <DialogContent>
        <div
          className=" start modal-content mx-auto pb-3 rounded-lg position-relative"
          style={{
            backgroundColor: "#F6FBF9",
            height: "95%",
            width: "90%",
            marginLeft: "20px",
            marginBottom: "20px"
          }}
        >
          <div className="start">

            <div
              className="  text-lg text-center pt-5"
              style={{ fontSize: 18, fontWeight: "bold" }}
            >
              Your Design
            </div>
            <div className="text-center pt-2 pb-5">
              <small>
                <b>Note:</b> You cannot edit the text content, You can only drag
                and adjust the position, size and alignment of your design
                content.
              </small>
            </div>
            <div className=" start d-flex justify-content-center">
              <div
                className=" down pl-1 d-flex justify-content-center "
                style={{ width: "70%" }}
              >
                <div
                  className="canva_border p-2 border border-red-800"
                  id="canva_border"
                >
                  <canvas id="canvas_t" />
                </div>
              </div>
              <div
                className=" down d-flex flex-column justify-content-center"
                style={{ width: "30%" }}
              >
                {/* {downloadNum === 3 ? (
                  <div style={{ width: 200, marginBottom: 20 }}>
                    Sorry,you've reached your download limit!{" "}
                    <a
                      className="text-primary"
                      style={{ textDecoration: "underline" }}
                      href="/"
                    >
                      Upgrade
                    </a>{" "}
                    to get the best of{" "}
                    <span style={{ fontWeight: "bold" }}>Ski Studio!</span>
                  </div>
                ) : (
                 
                )} */}

                <div
                  className=" word text-center"
                  style={{ width: 200, marginBottom: 20 }}
                >
                  <b>Download as: </b>
                </div>

                <button
                  type="button"
                  // disabled={downloadNum === 3 ? true : false}
                  className="btn btn-primary"
                  style={{ width: 80, marginLeft: 60 }}
                  onClick={() => addDownload("png")}
                >
                  <BsFileEarmarkImageFill
                    size={16}
                    style={{ marginBottom: 2, marginRight: 1 }}
                  />
                  PNG
                </button>

                {/* <button
                type="button"
                disabled={downloadNum === 3 ? true : false}
                className="btn btn-primary mt-3"
                style={{ width: 80, marginLeft: 60 }}
                onClick={() => addDownload("svg")}
              >
                SVG
              </button> */}
                <button
                  type="button"
                  // disabled={downloadNum === 3 ? true : false}
                  className="btn btn-primary but"
                  style={{ width: 80, marginLeft: 60 }}
                  onClick={() => addDownload("jpeg")}
                >
                  <BsFileEarmarkImageFill
                    size={16}
                    style={{ marginBottom: 2, marginRight: 1 }}
                  />
                  JPG
                </button>
              </div>
            </div>
          </div>
        </div>
        </DialogContent>
      </Dialog>

    </div>
  );
}
